import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeartInactive = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M21.4004 3C23.5292 3.00009 25.3588 3.724 26.8174 5.18262C28.276 6.64124 28.9999 8.47079 29 10.5996C29 11.6342 28.8255 12.6468 28.4785 13.6318C28.1249 14.6358 27.5207 15.6904 26.7031 16.791C25.8846 17.8929 24.7983 19.1158 23.457 20.457C22.1206 21.7934 20.4368 23.3762 18.4092 25.2031L18.4072 25.2041L16.668 26.7646C16.2881 27.1052 15.7119 27.1052 15.332 26.7646L13.5928 25.2041L13.5908 25.2031C11.5632 23.3762 9.87937 21.7934 8.54297 20.457C7.20171 19.1158 6.11539 17.8929 5.29687 16.791C4.47928 15.6903 3.87514 14.6358 3.52148 13.6318C3.17454 12.6468 3 11.6342 3 10.5996C3.00009 8.47079 3.724 6.64123 5.18262 5.18262C6.64123 3.724 8.47079 3.00009 10.5996 3C11.7858 3 12.9212 3.25166 13.9941 3.75391C14.734 4.10023 15.4021 4.5476 16 5.08887C16.5979 4.5476 17.266 4.10023 18.0059 3.75391C19.0788 3.25166 20.2142 3 21.4004 3Z",
			stroke: "white",
			strokeLinejoin: "round",
			strokeWidth: 2
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16 26.02L14.26 24.46C12.24 22.64 10.57 21.07 9.25 19.75C7.93 18.43 6.88 17.245 6.1 16.195C5.32 15.145 4.775 14.18 4.465 13.3C4.155 12.42 4 11.52 4 10.6C4 8.72 4.63 7.15 5.89 5.89C7.15 4.63 8.72 4 10.6 4C11.64 4 12.63 4.22 13.57 4.66C14.51 5.1 15.32 5.72 16 6.52C16.68 5.72 17.49 5.1 18.43 4.66C19.37 4.22 20.36 4 21.4 4C23.28 4 24.85 4.63 26.11 5.89C27.37 7.15 28 8.72 28 10.6C28 11.52 27.845 12.42 27.535 13.3C27.225 14.18 26.68 15.145 25.9 16.195C25.12 17.245 24.07 18.43 22.75 19.75C21.43 21.07 19.76 22.64 17.74 24.46L16 26.02Z",
			fill: "#4C4C4C"
		})]
	});
};
export default SvgHeartInactive;
